import { useSeoMeta } from "@unhead/react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { allPosts } from "@/lib/blog-posts";

const BlogPage = () => {
  useSeoMeta({
    title: "Let's Talk",
    description: "",
  });

  return (
    <div className="min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto space-y-12">
          {allPosts.map((post, index) => (
            <div key={index} className="border-b border-white/10 pb-8">
              <Link
                to={`/blog/${post.slug}`}
                className="group text-white font-semibold flex items-center gap-2"
              >
                <ArrowRight className="transition-transform group-hover:translate-x-1" size={20} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
